/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/grabber_medium'
export default icon
